import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  background-color: #FAFAFA;
`;

export const Header = styled.div`
  padding: 32px 0 24px;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #000;
  margin: 0;
`;

export const ProgressContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;
`;

export const ProgressDot = styled.div<{ active?: boolean; clickable?: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.active ? '#1FBC70' : '#D9D9D9'};
  transition: all 0.3s ease;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};

  ${props => props.clickable && `
    &:hover {
      transform: scale(1.3);
    }
  `}
`;

export const ContentWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #000;
  margin-bottom: 8px;
  margin-top: 16px;
  text-align: left;

  &:first-child {
    margin-top: 0;
  }
`;

export const HelperText = styled.div`
  font-size: 13px;
  color: #666;
  margin-top: 6px;
  margin-bottom: 0px;
  text-align: left;
  line-height: 1.5;
`;

export const ErrorText = styled.div`
  font-size: 13px;
  color: #FF4444;
  margin-top: 6px;
  margin-bottom: 0px;
  text-align: left;
  font-weight: 500;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const Input = styled.input`
  width: 100%;
  height: 48px;
  padding: 0 48px 0 16px;
  border: none;
  border-radius: 10px;
  background-color: #F0F0F0;
  font-size: 15px;
  color: #000;
  outline: none;

  &::placeholder {
    color: #999;
  }
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: none;
  background: #999;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
`;

export const ClearIcon = styled.span`
  color: white;
  font-size: 18px;
  font-weight: 300;
  line-height: 1;
`;

export const Timer = styled.div`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #1FBC70;
  font-size: 14px;
  font-weight: 600;
`;

export const TimerExpired = styled.div`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #FF4444;
  font-size: 14px;
  font-weight: 600;
`;

export const ResidentNumberContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background-color: #F0F0F0;
  border-radius: 12px;
  height: 56px;
`;

export const ResidentInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  font-size: 16px;
  color: #000;
  outline: none;

  &::placeholder {
    color: #999;
  }

  &:first-of-type {
    max-width: 120px;
  }
`;

export const Dash = styled.span`
  color: #000;
  font-size: 16px;
`;

export const PasswordDots = styled.span`
  color: #000;
  font-size: 16px;
  letter-spacing: 4px;
  flex: 2;
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const EmailContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const VerifyButton = styled.button`
  height: 48px;
  padding: 0 20px;
  border: none;
  border-radius: 10px;
  background-color: #1FBC70;
  color: white;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background-color: #18a860;
  }

  &:active {
    background-color: #159150;
  }

  &:disabled {
    background-color: #D9D9D9;
    cursor: not-allowed;
  }
`;

export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
  z-index: 10;
`;

export const DropdownItem = styled.div<{ selected?: boolean }>`
  padding: 16px 20px;
  cursor: pointer;
  font-size: 16px;
  color: ${props => props.selected ? '#1FBC70' : '#000'};
  background-color: ${props => props.selected ? '#F0FFF5' : 'white'};
  text-align: left;

  &:hover {
    background-color: #F8F8F8;
  }

  &:first-child {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  &:last-child {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`;

export const NoResult = styled.div`
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
`;

export const BottomButton = styled.button`
  width: 100%;
  height: 52px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  background-color: #1FBC70;
  border-radius: 12px;
  color: white;
  cursor: pointer;
  margin-bottom: 24px;
  margin-top: 32px;

  &:hover {
    background-color: #18a860;
  }

  &:active {
    background-color: #159150;
  }

  &:disabled {
    background-color: #D9D9D9;
    cursor: not-allowed;
  }
`;

export const ProfileImageSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  position: relative;
`;

export const ProfileImageContainer = styled.div`
  position: relative;
  width: 200px;
  height: 200px;
`;

export const ProfileImageWrapper = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
`;

export const ProfileImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ProfileImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background-color: #F0F0F0;
`;

export const AddPhotoButton = styled.button`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #999;
  border: 4px solid #FAFAFA;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #777;
  }

  &::before {
    content: '+';
    font-size: 28px;
    font-weight: 400;
    color: #000;
    line-height: 1;
  }
`;

export const CameraIcon = styled.div`
  font-size: 48px;
`;

export const ProfileImageText = styled.div`
  font-size: 14px;
  color: #666;
  font-weight: 500;
`;

export const PasswordToggleButton = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
`;

export const PasswordToggleIcon = styled.img`
  width: 20px;
  height: 20px;
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }
`;
